module.exports = __webpack_public_path__ + "img/result-bg.90b8f2f9.jpg";